import { ReactElement, useContext } from "react"

import AppStepper from "../../../../dataDisplay/stepper/appStepper"
import { NON_SYS_ADMIN_EVDC_STEPS_AMEND } from "../../formSpecs/evdcSpec"
import { AmendEVDCDeviceContext } from "../providers/baseProviders/amendEVDCDeviceProvider"

/** AppStepper for amending an EVDC device */
const AmendEvdcDeviceProgressStepper = (): ReactElement => {
    const { currentIndex } = useContext(AmendEVDCDeviceContext)

    return (
        <AppStepper
            stepLabels={NON_SYS_ADMIN_EVDC_STEPS_AMEND}
            currentStepIndex={currentIndex}
        />
    )
}

export default AmendEvdcDeviceProgressStepper
